function elementExist(selector, callback) {
  const element = document.querySelector(selector)
  if (element) {
    callback(element)
  } 
  else {
    const observer = new MutationObserver(() => {
      const target = document.querySelector(selector)
      if (target) {
        observer.disconnect()
        callback(target)
      }
    })
	observer.observe(document.body, { childList: true, subtree: true })
  }
} 


elementExist('.blced-item--scroll', ( node ) => {
  const sliderSlides = document.querySelectorAll('.blced-item--scroll')

  if( sliderSlides.length > 0 ) {
    const sliderSection = document.createElement('section')
    sliderSection.className = 'blced-section--scroll splide'

    const sliderTrack = document.createElement('div')
    sliderTrack.className = 'splide__track'

    const sliderList = document.createElement('div')
    sliderList.className = 'splide__list'

    sliderSlides.forEach(slide => {
      const slideParent = slide.parentNode
      slideParent.classList.add('splide__slide')
      sliderList.appendChild(slideParent)
    })

    sliderTrack.appendChild(sliderList)
    sliderSection.appendChild(sliderTrack)

    const mainContent = document.getElementById('MainContent')
    mainContent.insertBefore(sliderSection, mainContent.firstChild)


    splideScroll = new Splide( '.blced-section--scroll.splide', {
      height      : '100vh',
      direction   : 'ttb',
      speed       : 1300, 
      wheel       : true,
      wheelSleep  : 1000,
      drag        : false,
      arrows      : false,
      mediaQuery  : 'max',
      breakpoints : {
        749: {
          pagination : false,
          drag       : true
        },
      }
    })
    splideScroll.mount()
  }
})


window.addEventListener( 'load', () => {
  /* Component: section scroll */
  /*const sliderSlides = document.querySelectorAll('.blced-item--scroll')

  if( sliderSlides.length > 0 ) {
    const sliderSection = document.createElement('section')
    sliderSection.className = 'blced-section--scroll splide'

    const sliderTrack = document.createElement('div')
    sliderTrack.className = 'splide__track'

    const sliderList = document.createElement('div')
    sliderList.className = 'splide__list'

    sliderSlides.forEach(slide => {
      const slideParent = slide.parentNode
      slideParent.classList.add('splide__slide')
      sliderList.appendChild(slideParent)
    })

    sliderTrack.appendChild(sliderList)
    sliderSection.appendChild(sliderTrack)

    const mainContent = document.getElementById('MainContent')
    mainContent.insertBefore(sliderSection, mainContent.firstChild)


    splideScroll = new Splide( '.blced-section--scroll.splide', {
      height      : '100vh',
      direction   : 'ttb',
      speed       : 1300, 
      wheel       : true,
      wheelSleep  : 1000,
      drag        : false,
      arrows      : false,
      mediaQuery  : 'max',
      breakpoints : {
        749: {
          pagination : false,
          drag       : true
        },
      }
    })
    splideScroll.mount() */

    /* splideScroll.on("before-slide", (newIndex, prevIndex) => {
      if (newIndex === 0) {
        // Evita que el carrusel se desplace hacia arriba desde la primera diapositiva.
        splideScroll.go(prevIndex);
      } else if (newIndex === splideScroll.length - 1) {
        // Evita que el carrusel se desplace hacia abajo desde la última diapositiva.
        splideScroll.go(prevIndex);
      }
    }); */
    /*splideScroll.on('drag', (event) => {
      console.log(event)
      if ( (splideScroll.index === 0 && e.direction === 'btt' ) || (splideScroll.index === splideScroll.length - 1 && e.direction === 'ttb' ) ) {
        console.log('arriba')
        console.log(e)
      }
    });  
  } */


  /* Script that adds add to cart and quantity buttons in a container */
  const productQuantity = document.querySelector('.template--product .product-form__quantity')
  const productButtons = document.querySelector('.template--product .product-form')

  if (productQuantity && productButtons) {
    const containerParent = productQuantity.parentNode

    const productFormAll = document.createElement('div')
    productFormAll.classList.add('product-form--all')

    containerParent.insertBefore(productFormAll, productQuantity)
  
    productFormAll.appendChild(productQuantity)
    productFormAll.appendChild(productButtons.parentNode)
  }


  /* Script menu hover */
  const itemsMenu = document.querySelector( '.header__inline-menu' ).querySelectorAll( 'details' )
  if( itemsMenu ) {
    itemsMenu.forEach( item => {
      item.addEventListener( 'mouseover', () => {
        item.setAttribute( 'open', true )
        item.querySelector( 'ul' ).addEventListener( 'mouseleave', () => item.removeAttribute( 'open' ) )
        item.addEventListener( 'mouseleave', () => item.removeAttribute( 'open' ) )
      })
    })
  }

  
  /* App: Recharge */
  const radioOneTime = document.querySelector('.recharge-subscription-widget .onetime-radio')
  if (radioOneTime) {
    const labelRadio = radioOneTime.querySelector('.rc-radio__label')
    const price = labelRadio.textContent.match(/\$[\d.]+/)
    
    const priceSpan = document.createElement('span')
    priceSpan.className = 'rc-radio__price'
    priceSpan.textContent = price[0]

    labelRadio.innerHTML = labelRadio.innerHTML.replace(price[0], '');
    labelRadio.appendChild(priceSpan)
  }


  /* Component: Tabs */
  const tabs = document.querySelectorAll('.blced--tabs .blced--tabs-item-label')
  const tabsContent = document.querySelectorAll('.blced--tabs .blced--tabs-item-content')
  
  if(tabs && tabsContent) {
    tabsContent[0].classList.add('active')
    tabs[0].classList.add('active')

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {

        tabs.forEach( tabs => tabs.classList.remove('active') )
        tabsContent.forEach( item => item.classList.remove('active') )

        tab.classList.add('active')
        tabsContent[index].classList.add('active')
      })
    }) 
  }

  
  /* App: Reviews */
  elementExist('.template--product .AirReviews-Widget--Stars .AirReviews-StarRate--Count', ( node ) => {
    if ( node ) {
      const countReviews = node.textContent.match(/\((\d+)\)/)
      if (countReviews && countReviews.length > 1) {
        node.textContent = `(${countReviews[1]} customer reviews)`

        const tabReview = document.querySelector('.blced--tabs .blced--tabs-Reviews span')
        tabReview.textContent = `Reviews (${countReviews[1]})`
      }
    }
  }) 

  /* Hover starts */
  const startsReviews = document.querySelectorAll('.template--product .AirReviews-Blocks--Actions svg')
  if( startsReviews ) {
    startsReviews.forEach((star, index) => {
      star.addEventListener('mouseover', () => {
        for (let i = 0; i <= index; i++) {
          startsReviews[i].classList.add('start--active')
        }
      })
    
      star.addEventListener( 'mouseout', () => {
        startsReviews.forEach((s, i) => {
          s.classList.remove('start--active')
        })
      })
    })
  }

})